/**
 *
 * @param {string} language eg. en-US
 * @param {string[]} keys locale file paths
 * @returns
 */
export default function isLocaleExists(language: string, keys: string[]) {
  if (!language) return false

  const files = [
    `/${language.replace(/(-\S{2,})/, (match: string, $1: string) =>
      $1.toUpperCase()
    )}`,
    `/${language}`,
    `/${language.match(/(\S{2,3})-/)?.[1]}`,
  ]

  for (const file of files) {
    const lower = file.toLowerCase()
    const found = keys.find((v: string) => v.toLowerCase().indexOf(lower) > -1)
    if (found) return found
  }
  return false
}
